/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { hideLoaderAction, showLoaderAction } from "./loaderActionCreator";

export function showLoader(dispatch: (arg0: { type: string; displayLoader: boolean }) => void) {
    dispatch(showLoaderAction());
}

export function hideLoader(dispatch: (arg0: { type: string; displayLoader: boolean }) => void) {
    dispatch(hideLoaderAction());
}
